module.exports = __webpack_public_path__ + "img/monastery_tech_Normal_ua.c9fd3e08.webp";